module.exports = __webpack_public_path__ + "static/img/img-video-bg.49a0e0cb.png";